// @flow
import * as React from 'react';
import Radium from 'radium';
import { connect } from 'react-redux';
import { compose, withState } from 'recompose';
import type { ReportState } from 'types';

import SelectableState from 'components/SelectableState';

import {
  Card,
  CardHeader,
  CardBlock,
  Button,
  FormGroup,
  Input,
} from 'reactstrap';
import { changeState, loadSingleReport } from 'actions/reports';

const STATES = ['new', 'in-progress', 'finished', 'declined'];

type Props = {
  currentState: ReportState,
  reportId: string,

  // recompose
  newState: ?ReportState,
  onNewStateChange: (state: ?ReportState) => void,
  reason: string,
  onReasonChange: (reason: string) => void,

  // redux
  onChangeState: (state: ReportState, reason: string) => void,
  onLoadSingleReport: () => void,
};

class ChangeStatus extends React.Component<Props> {
  _onChangeState = async () => {
    const {
      newState,
      onNewStateChange,
      onChangeState,
      reason,
      onLoadSingleReport,
    } = this.props;
    !!newState && (await onChangeState(newState, reason));
    await onLoadSingleReport();
    onNewStateChange(null);
  };

  render() {
    const {
      currentState,
      newState,
      onNewStateChange,
      reason,
      onReasonChange,
    } = this.props;

    return (
      <Card style={styles.root}>
        <CardHeader style={styles.title}>Status ändern</CardHeader>
        <CardBlock>
          {STATES.map(state => (
            <SelectableState
              key={state}
              state={state}
              subtext={
                state === currentState
                  ? '(aktueller Status)'
                  : state === newState ? '(neuer Status)' : ''
              }
              selected={state === currentState}
              onClick={() => onNewStateChange(state)}
            />
          ))}
          {newState === 'declined' && (
            <FormGroup>
              <Input
                type="textarea"
                placeholder="Warum soll diese Meldung abgelehnt werden?"
                value={reason}
                onChange={event => onReasonChange(event.target.value)}
              />
            </FormGroup>
          )}
          <Button
            color="primary"
            disabled={
              newState === currentState ||
              !newState ||
              (newState === 'declined' && !reason)
            }
            onClick={this._onChangeState}
          >
            Status ändern
          </Button>
        </CardBlock>
      </Card>
    );
  }
}

const styles = {
  root: {
    width: '100%',
  },
  title: {
    fontWeight: 'bold',
  },
};

const mapStateToProps = ({}) => ({});
const mapDispatchToProps = (dispatch, { reportId }) => ({
  onChangeState: (state, reason) =>
    dispatch(changeState(reportId, state, reason)),
  onLoadSingleReport: () => dispatch(loadSingleReport(reportId)),
});

const ChangeStatusContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('newState', 'onNewStateChange', null),
  withState('reason', 'onReasonChange', ''),
  Radium
)(ChangeStatus);

export default ChangeStatusContainer;



// WEBPACK FOOTER //
// ./src/components/ChangeStatus/ChangeStatus.js